import { Grid, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useGetCoursesReviewsQuery } from "../../../../app/features/courses/courses.api";
import IMAGES from "../../../../assets/images";
import ReviewItem from "../../../../components/ui/ReviewItem";
import Title from "../../../../components/ui/Title";
import useError from "../../../../hooks/useError";
import ReviewLoading from "../../story/_components/ReviewLoading";

// Remove these imports if using CDN
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/grid';

export default function SuccessStory() {
  const { data, isLoading, error } = useGetCoursesReviewsQuery({});
  useError(error, "Failed to load reviews list");

  const items = data?.items || [];

  return (
    <section className="py-12 lg:py-24 bg-[#F0F3F9]">
      <div className="container mini-container">
        <Title className="text-center mb-2 mt-4">সফলতার গল্প</Title>
        <p className="text-theme-slate-700 text-base lg:text-lg max-w-xl mx-auto text-center">
          যারা শিখে নিজেদের জীবন বদলে দিয়েছে, তাদের অনুপ্রেরণামূলক গল্প।
        </p>

        <div className="mt-16">
          {isLoading && (
            <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
              <ReviewLoading />
            </div>
          )}

          {!isLoading && items.length <= 6 && (
            <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
              {items.map((item, i) => (
                <ReviewItem
                  key={i}
                  img={item.userAvatar || IMAGES.avatar}
                  text={item.comment || ""}
                  name={item.userName || ""}
                  rating={item.rating || 0}
                />
              ))}
            </div>
          )}

          {!isLoading && items.length > 6 && (
            <Swiper
              modules={[Navigation, Pagination, Grid]}
              spaceBetween={24}
              slidesPerView={1}
              slidesPerGroup={1}
              grid={{
                rows: 2,
                fill: "row",
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              navigation={true}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  slidesPerGroup: 1,
                  grid: {
                    rows: 2,
                    fill: "row",
                  },
                },
                1024: {
                  slidesPerView: 2,
                  slidesPerGroup: 2,
                  grid: {
                    rows: 2,
                    fill: "row",
                  },
                },
                1280: {
                  slidesPerView: 3,
                  slidesPerGroup: 3,
                  grid: {
                    rows: 2,
                    fill: "row",
                  },
                },
              }}
              className="success-story-swiper pb-12"
            >
              {items.map((item, i) => (
                <SwiperSlide key={i} className="h-auto">
                  <ReviewItem
                    img={item.userAvatar || IMAGES.avatar}
                    text={item.comment || ""}
                    name={item.userName || ""}
                    rating={item.rating || 0}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
}
